
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[app-slug]/licenses",
      function () {
        return require("private-next-pages/[app-slug]/licenses.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[app-slug]/licenses"])
      });
    }
  